export default __webpack_public_path__ + "d61e8fc3b702bdbf3b2a1598b202551e.png";